<template>
  <div>
    <basic-alert :active="alertActive" :type="alertType" :msg="alertMsg" />
    <view-container>
      <v-container>
        <v-row>
          <v-col cols="2">
            <basic-btn
              xLarge
              icon="mdi-arrow-left"
              style="margin: 7px"
              @click="
                pasos === 1
                  ? $router.push('/client/Historic')
                  : (pasos = pasos - 1)
              "
            />
          </v-col>
          <v-col cols="10">
            <h1 v-text="'Ubicación De La Reserva'" />
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row>
          <v-col cols="12" sm="12" md="12"> </v-col>
          <v-col cols="12" sm="12" md="12" class="out-padding">
            <auto-container
              style="overflow: auto;"
              :dimension="'100'"
              color="#F7F9F9"
            >
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <span v-text="locationName" class="text-h5 colorLinde" />
                    <br />
                    <span
                      v-text="
                        moment(initDate).format('D/MM/YYYY h:mm:ss A') +
                          ' a ' +
                          moment(lastDate).format('h:mm:ss A')
                      "
                      class="colorLinde2"
                    />
                  </v-col>
                  <v-col cols="12">
                    <div class="scroll-container">
                      <canvas
                        class="scroll-container"
                        v-on:mousemove="findPlace"
                        v-on:click="bootomModal"
                        id="myArea"
                        style="
                      max-width: 250% 
                    "
                      ></canvas>
                      <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                        v-if="searchImg"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </auto-container>
          </v-col>
        </v-row>
      </v-container>
      <v-bottom-sheet v-model="sheet2">
        <v-sheet class="text-left" style="padding:2%">
          <auto-container :dimension="'50'" color="white" borderOff>
            <h2 class="colorLinde" v-text="locationName" />
            <span v-text="workplaceDetail.nombre" class="text-h5 colorLinde" />
            <v-sheet height="400">
              <v-calendar
                ref="calendar"
                :now="calendarDay"
                :value="calendarDay"
                :events="events"
                color="primary"
                type="day"
                locale="es-MX"
              ></v-calendar>
            </v-sheet>
          </auto-container>
        </v-sheet>
      </v-bottom-sheet>
    </view-container>
  </div>
</template>

<script>
import moment from "moment";
import moment_tz from "moment-timezone";
import Scroller from "@/components/Scroller";
import { services, time } from "@/utils";
import { userImg } from "@/assets";

import {
  AutoContainer,
  ViewContainer,
  BasicInput,
  BasicBtn,
  SearchBox,
  InfoList,
  SelectBtn,
  WeekBtn,
  SelectUp,
  InputBtn,
  BasicAlert,
} from "@/components";

export default {
  name: "home",
  components: {
    AutoContainer,
    ViewContainer,
    BasicInput,
    BasicBtn,
    SearchBox,
    InfoList,
    SelectBtn,
    WeekBtn,
    Scroller,
    SelectUp,
    InputBtn,
    BasicAlert,
  },
  data: () => ({
    userImg: userImg,
    ubicacionId: undefined,
    initDate: undefined,
    lastDate: undefined,
    events: [],
    workplaceInfo: [],
    workplaceDetail: [],
    auxMap: undefined,
    alertActive: false,
    searchImg: false,
    alertMsg: "",
    alertType: "error",
    locationName: "",
    spaceName: "",
    spaceAvaible: false,
    spaceReserv: 0,
    text: null,
    sheet2: false,
    time: null,
    sheet3: false,
    pasos: 1,
    capa: 0,
    areas: [],
    workplaces: [],
    reservationType: [],
    days: [],
  }),
  mounted() {
    this.ubicacionId = this.$route.query.id;
    this.initDate = this.$route.query.initDate;
    this.lastDate = this.$route.query.lastDate;
    this.locationName = this.$route.query.location
      ? this.$route.query.location
      : "Ubicacion desconocida";
    this.getLayout();
  },
  computed: {
    dates() {
      return this.days.map((day) => day.date);
    },
    calendarDay() {
      return moment(this.$route.query.initDate).format("YYYY-MM-D");
    },
    updateWorkplace() {
      return this.reservationType;
    },
    attributes() {
      return this.dates.map((date) => ({
        highlight: true,
        dates: date,
      }));
    },
  },
  watch: {
    alertActive(new_val) {
      if (new_val) {
        setTimeout(() => {
          this.alertActive = false;
        }, 3000);
      }
    },
  },
  methods: {
    allowedStep: (m) => m % 30 === 0,
    isInside(point, place) {
      let pX = point.x;
      let pY = point.y;
      let x1 = place.x;
      let y1 = place.y;
      let x2 = place.x + place.w;
      let y2 = place.y + place.h;
      if (pX >= x1 && pX <= x2 && pY >= y1 && pY <= y2) {
        return true;
      }
    },
    findPlace(e) {
      let x = e.offsetX;
      let y = e.offsetY;
      for (let i = 0; i < this.workplaces.length; i++) {
        if (this.isInside({ x, y }, this.workplaces[i].coordenadas)) {
          this.auxMap = JSON.parse(JSON.stringify(this.workplaces[i]));
          this.openInfo = true;
          break;
        } else {
          this.openInfo = false;
        }
      }
    },
    getLayout() {
      this.searchImg = true;
      let data = {
        detReservacionID: this.ubicacionId,
      };
      services
        .ws("get", "detailReservation", data, "params")
        .then((res) => {
          if (res.ok) {
            this.workplaces = res.data.lugaresTrabajo;
            this.workplaceInfo = res.data.lugarTrabajo;
            let layout = res.data.layout.data;
            this.forms =
              "data:image/png;base64," +
              btoa(
                new Uint8Array(layout).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.searchImg = false;
          var img = document.getElementById("img");
          this.makeArea();
        });
    },
    makeArea() {
      var siteMarks = this.workplaces;
      var myLocation = this.workplaceInfo.id;
      this.loading = true;
      setTimeout(() => {
        const _this = this;
        function draw() {
          ctx.drawImage(baseImage, 0, 0, ctx.canvas.width, ctx.canvas.height);
          ctx.lineWidth = 2;

          for (let site of siteMarks) {
            if (myLocation == site.id) {
              ctx.strokeStyle = "rgba(0, 160, 225, 0.9)";
              ctx.fillStyle = "rgba(0, 160, 225, 0.5)";
            } else {
              ctx.strokeStyle = "#979797b6";
              ctx.fillStyle = "#535353b0";
            }
            ctx.strokeRect(
              site.coordenadas.x,
              site.coordenadas.y,
              site.coordenadas.w,
              site.coordenadas.h
            );
            ctx.fillRect(
              site.coordenadas.x,
              site.coordenadas.y,
              site.coordenadas.w,
              site.coordenadas.h
            );
          }
        }
        function mainLoop() {
          if (
            _this.forms &&
            (refresh || mouse.down || mouse.up || mouse.button)
          ) {
            refresh = false;
            if (mouse.down) {
              mouse.down = false;
              rect.restart(mouse);
            } else if (mouse.button) {
              rect.update(mouse);
            } else if (mouse.up) {
              mouse.up = false;
              rect.update(mouse);
              let coors = rect.toRect();
            }
            draw();
          }
          _this.idAnimation = window.requestAnimationFrame(mainLoop);
        }
        function loadImage(url) {
          const image = new Image();
          image.src = url;
          image.onload = function() {
            canvas.width = this.width;
            canvas.height = this.height;
            refresh = true;
          };
          return image;
        }
        this.idAnimation = window.requestAnimationFrame(mainLoop);
        const canvas = document.getElementById("myArea");
        const ctx = canvas.getContext("2d");
        const baseImage = loadImage(this.forms);
        var refresh = true;
        const rect = (() => {
          var x1, y1, x2, y2;
          var show = false;
          function fix() {
            rect.x = Math.min(x1, x2);
            rect.y = Math.min(y1, y2);
            rect.w = Math.max(x1, x2) - Math.min(x1, x2);
            rect.h = Math.max(y1, y2) - Math.min(y1, y2);
          }
          function draw(ctx) {
            ctx.strokeRect(this.x, this.y, this.w, this.h);
            ctx.fillStyle = "rgba(0, 160, 225, 0.5)";
            ctx.fillRect(this.x, this.y, this.w, this.h);
          }
          const rect = { x: 0, y: 0, w: 0, h: 0, draw };
          const API = {
            restart(point) {
              x2 = x1 = point.x;
              y2 = y1 = point.y;
              fix();
              show = true;
            },
            update(point) {
              x2 = point.x;
              y2 = point.y;
              fix();
              show = true;
            },
            toRect() {
              show = false;
              return Object.assign({}, rect);
            },
            draw(ctx) {
              if (show) {
                rect.draw(ctx);
              }
            },
            show: false,
          };
          return API;
        })();
        const mouse = {
          button: false,
          x: 0,
          y: 0,
          down: false,
          up: false,
          element: null,
          event(e) {
            if (!_this.forms) {
              return false;
            }
            const m = mouse;
            m.bounds = m.element.getBoundingClientRect();
            m.x = e.pageX - m.bounds.left - scrollX;
            m.y = e.pageY - m.bounds.top - scrollY;
            const prevButton = m.button;
            m.button =
              e.type === "mousedown"
                ? true
                : e.type === "mouseup"
                ? false
                : mouse.button;
            if (!prevButton && m.button) {
              m.down = true;
            }
            if (prevButton && !m.button) {
              m.up = true;
            }
          },
          start(element) {
            mouse.element = element;
            "down,up,move"
              .split(",")
              .forEach((name) =>
                document.addEventListener("mouse" + name, mouse.event)
              );
          },
        };
        if (!this.flagEvent) {
          mouse.start(canvas);
          this.flagEvent;
        }
        this.loading = false;
      }, 1000);
    },

    viewArea(item) {
      this.areas = item.areas;
    },
    pointLocationH(item) {
      var img = document.getElementById("img");
      var altoOriginal = img.naturalHeight;
      var anchoDefinido = img.naturalWidth;

      return item.x;
    },

    getDetailsWorkPlace() {
      this.events = [];
      let data = {
        lugarTrabajoID: this.auxMap.id,
        zonaHoraria: moment_tz.tz.guess(),
        fecha: moment(this.initDate)
          .utc()
          .format("yyyy-MM-DD"),
      };
      services
        .ws("get", "workplace", data, "params")
        .then((res) => {
          if (res.ok) {
            this.workplaceDetail = res.data;

            for (
              let i = 0;
              i < this.workplaceDetail.reservaciones.length;
              i++
            ) {
              this.events.push({
                name: this.workplaceDetail.reservaciones[i].empleado.nombre,
                start:
                  this.calendarDay +
                  " " +
                  this.workplaceDetail.reservaciones[i].horaInicio,
                end:
                  this.calendarDay +
                  " " +
                  this.workplaceDetail.reservaciones[i].horaFin,
              });
            }
          } else {
            this.alertActive = true;
            this.alertMsg = "No existen lugares de trabajo";
            this.alertType = "error";
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    bootomModal() {
      if (this.openInfo) {
        this.getDetailsWorkPlace();
        if (this.auxMap.tipoLugarTrabajo == "Sala de juntas") {
          this.sheet3 = !this.sheet3;
        } else {
          this.sheet2 = !this.sheet2;
        }
        this.spaceName = this.auxMap.nombre + " " + this.auxMap.codigo;
        this.spaceAvaible = this.auxMap.disponible;
        this.spaceReserv = this.auxMap.id;
      }
    },
  },
};
</script>

<style scoped>
h1,
.colorLinde {
  color: #005591;
}

.colorLinde2 {
  color: #00a0e1;
}

.one {
  display: flex !important;
  align-items: flex-end !important;
}

.upImg {
  position: relative /* o absolute*/;
  top: 220px;
  left: 220px;
  z-index: 99;
}
v-img {
  width: 423px;
  height: 644px;
}
.scroll-container {
  height: 100%;
  overflow-y: scroll;
  overflow-x: scroll;
  backface-visibility: hidden;
}
</style>
